import React from "react";
import OrderCard from "./OrderCard";
import EmptyState from "./EmptyState";

export default function OrdersGrid({ orders = [], onStatusUpdate }) {
  if (!orders.length) return <EmptyState />;

  return (
    <div className="lo-grid">
      {orders.map(o => (
        <OrderCard key={o.id} order={o} onStatusUpdate={onStatusUpdate} />
      ))}
    </div>
  );
}
